export class TributeInfo {
  public firstName = '';
  public lastName = '';
  public email = '';
  public phone = '';
  public address1 = '';
  public address2 = '';
  public city = '';
  public state = null;
  public zip = '';
  public country = null;
  public from = '';
  public id = '';
  public completed = false;
  public honorees: {
    firstname: string;
    lastname: string;
    message: string;
  }[] = [{ firstname: '', lastname: '', message: '' }];
}
